import styled from "@emotion/styled";
import { Button, Text, Variables } from "@repo/skapa";
import { LightMode } from "@repo/skapa";
import { type ReactNode } from "react";

interface ErrorPageProps {
  image: ReactNode;
  title: string;
  description: string;
  link?: string;
  buttonText?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${Variables.space75};
  padding: ${Variables.space400} ${Variables.space200} ${Variables.space400};
  background-color: ${LightMode.colourNeutral1};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Variables.space50};
  max-width: 650px;
`;

const Description = styled(Text)`
  text-align: center;
  white-space: pre-wrap;
`;

export const ErrorPage = ({
  image,
  title,
  description,
  link,
  buttonText,
}: ErrorPageProps) => {
  return (
    <Container>
      <Content>
        {image}
        <Text textStyle="Heading.S" tagName="h1">
          {title}
        </Text>
        <Description textStyle="Body.L" tagName="p">
          {description}
        </Description>
        {buttonText && link && (
          <Button type="primary" href={link}>
            {buttonText}
          </Button>
        )}
      </Content>
    </Container>
  );
};
